export const isUnreplacedPlaceholderImage = (item) => (item === null || item === void 0 ? void 0 : item.placeholder) === true && item.placeholderReplaced !== true;
//# sourceMappingURL=typeguards.js.map